export default "__VITE_ASSET__B70KS6ew__"